<p-card>
  <ng-template #title>{{ "measurement.insight.title" | translate }}</ng-template>
  <ng-template #subtitle>{{ "measurement.insight.subtitle" | translate }}</ng-template>

  @if (temperatures()?.length && temperatures()![temperatures()!.length - 1] != null) {
    <div>
      <p>
        <span class="h2">
          {{ temperatures()![temperatures()!.length - 1] | number:'1.2-2' }} {{ "measurement.insight.temperature" | translate }}
        </span>
        <small>{{ "measurement.insight.curr_temperature" | translate }}</small>
      </p>

      @if (specifications_temperature() != null && specifications_temperature()!.length) {
        <div>
          <p class="h6">
            @if (temperatures()![temperatures()!.length - 1] && temperatures()![temperatures()!.length - 1] < specifications_maturity()![specifications_maturity()!.length - 1]) {
              <span style="color:red;">{{ "measurement.insight.not_reached" | translate }}</span>
            }
            @if (temperatures()![temperatures()!.length - 1] && temperatures()![temperatures()!.length - 1] > specifications_maturity()![specifications_maturity()!.length - 1]) {
              <span style="color:green;">{{ "measurement.insight.reached" | translate }}</span>
            }
          </p>
          <p class="h6">
            {{ "measurement.insight.maturity_at" | translate }}
            @if (temperatures()![temperatures()!.length - 1]) {
              <span>{{ temperatures()![temperatures()!.length - 1] | number:'1.2-2' }}</span>
            }
            {{ "measurement.insight.out_of" | translate }} {{ specifications_maturity()![specifications_maturity()!.length - 1] | number:'1.0-2' }} {{ "measurement.insight.maturity_days" | translate }}
          </p>
          <p-progressbar
            class="mb-3"
            color="primary"
            [value]="100 * temperatures()![temperatures()!.length - 1] / specifications_maturity()![specifications_maturity()!.length - 1]"
            [showValue]="false"
          ></p-progressbar>
          <div class="strength-checkpoints-container">
            @for (checkpoint of specifications_temperature(); track checkpoint; let i = $index; let first = $first; let last = $last) {
              @if (first && !last) {
                <div class="strength-checkpoint"
                  [class.reached]="temperatures()![temperatures()!.length - 1] > checkpoint"
                  [style.width.%]="100 * checkpoint / specifications_temperature()![specifications_temperature()!.length - 1]">
                  {{ checkpoint }} {{ "measurement.insight.temperature" | translate }}
                </div>
              }
              @if (!first) {
                <div class="strength-checkpoint"
                  [class.reached]="temperatures()![temperatures()!.length - 1] > checkpoint"
                  [style.width.%]="100 * (checkpoint - specifications_temperature()![i - 1]) / specifications_temperature()![specifications_temperature()!.length - 1]">
                  {{ checkpoint }} {{ "measurement.insight.temperature" | translate }}
                </div>
              }
              @if (first && last) {
                <div class="strength-checkpoint last-checkpoint"
                  [class.reached]="temperatures()![temperatures()!.length - 1] > checkpoint">
                  {{ checkpoint }} {{ "measurement.insight.temperature" | translate }}
                </div>
              }
            }
          </div>
        </div>
      }

      <p-divider></p-divider>

      <p>
        <span class="h3">{{ maxTemp() | number:'1.2-2' }} {{ "measurement.insight.temperature" | translate }}</span>
        <small>{{ "measurement.insight.max_temperature" | translate }}</small>
      </p>

      <p-divider></p-divider>

      <p>
        <span class="h3">{{ average() | number:'1.2-2' }} {{ "measurement.insight.temperature" | translate }}</span>
        <small>{{ "measurement.insight.avg_temperature" | translate }}</small>
      </p>

      <p-divider></p-divider>

      <p>
        <span class="h3">{{ minTemp() | number:'1.2-2' }} {{ "measurement.insight.temperature" | translate }}</span>
        <small>{{ "measurement.insight.min_temperature" | translate }}</small>
      </p>
    </div>
  }

  <p-divider></p-divider>

  <p class="mt-4">
    {{ 'measurement.lastSeen' | translate }}:
    @if (time()) {
      <span>{{ time() | date:'dd/MM/yyyy HH:mm:ss' }}</span>
    } @else {
      <span>{{ 'measurement.insight.no_data' | translate }}</span>
    }
  </p>
</p-card>
